export default __webpack_public_path__ + "static/schwizgebel-ac580b26475811bca4d52e17ace11e41.jpg";